<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="2">
                  <b-form-group label-for="month" label="Bulan">
                    <model-select
                      id="month"
                      :options="listMonth"
                      v-model="currentMonth"
                      placeholder="Bulan"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group label-for="year" label="Tahun">
                    <model-select
                      id="year"
                      :options="listYear"
                      v-model="currentYear"
                      placeholder="Tahun"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group label-for="division" label="Divisi">
                    <model-select
                      id="division"
                      :options="listEmployeeDivision"
                      v-model="currentDivision"
                      @input="setSelected"
                      placeholder="Divisi"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group label-for="position" label="Posisi">
                    <model-select
                      id="position"
                      :options="listEmployeePosition"
                      v-model="currentPosition"
                      placeholder="Posisi"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group label-for="status" label="Status">
                    <model-select
                      id="status"
                      :options="listEmployeeStatus"
                      v-model="currentStatus"
                      placeholder="Status"
                    ></model-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="12">
                  <b-button
                    size="sm"
                    variant="stack-overflow"
                    class="mr-1 btn-brand"
                    @click="getListingAttendance"
                  >
                    <i class="fa fa-search"></i>
                    <span>Filter</span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <div slot="header">
            <div class="float-left">Absensi Karyawan</div>
          </div>
          <b-card-body>
            <!-- <b-row v-if="!loading">
              <b-col lg="12">
                <b-button
                  size="sm"
                  variant="stack-overflow"
                  class="mr-1 btn-brand"
                  @click="openMultipleAttendanceForm"
                >
                  <i class="fa fa-upload"></i>
                  <span>Buat absen</span>
                </b-button>
              </b-col>
            </b-row>
            <br /> -->
            <b-row>
              <b-col lg="12">
                <attendance-list
                  :loading="loading"
                  :day-in-month="day_in_month"
                  :list-attendance="listAttendance"
                  :month="currentMonth"
                  :year="currentYear"
                  @reload="getListingAttendance"
                  @doAttendance="openAttendanceForm"
                  @showHistory="getListHistory"
                ></attendance-list>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- <b-modal
      ref="multipleAbsensiForm"
      id="addMultipleModals"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Absensi Kehadiran Karyawan</h3>
      </div>
      <b-form id="multipleAttendanceForm" validated novalidate @submit="multipleSubmitAttendance">
        <div v-if="!loadingSubmit">
          <b-row>
            <b-col lg="4">
              <b-row>
                <b-col>
                  <b-form-group label-for="attendance_date" label="Tanggal Absensi">
                    <v-date-picker
                      id="attendance_date"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Absensi', required: ''}"
                      :state="!$v.attendanceForm.attendance_date.$invalid"
                      v-model="$v.attendanceForm.attendance_date.$model"
                    ></v-date-picker>
                    <div
                      v-if="$v.attendanceForm.attendance_date.$invalid"
                      class="invalid-feedback-custom"
                    >Tanggal absensi harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-form-group label-for="employee_id" label="Karyawan">
                    <model-select
                      id="employee_id"
                      :options="listEmployee"
                      v-model="tempEmployeeMultiple"
                      :isError="$v.attendanceForm.employee_id.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                      @input="changeEmployeeMultiple"
                    ></model-select>
                    <div
                      v-if="attendanceForm.employee_id === null"
                      class="invalid-feedback-custom"
                    >Karyawan harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label-for="attendance_status" label="Status">
                    <model-select
                      id="attendance_status"
                      :options="listAttendanceStatus"
                      v-model="tempEmployeeStatus"
                      :isError="$v.attendanceForm.attendance_status.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                      @input="changeEmployeeStatus"
                    ></model-select>
                    <div
                      v-if="attendanceForm.attendance_status === null"
                      class="invalid-feedback-custom"
                    >Status kehadiran harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label-for="notes" label="Notes">
                    <b-form-textarea
                      id="notes"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.attendanceForm.notes.$model"
                      :state="!$v.attendanceForm.notes.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Notes harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="float-right">
                    <b-button
                      type="button"
                      size="sm"
                      variant="primary"
                      @click="addMultipleAttendance"
                    >
                      <i class="fa fa-add"></i> Add
                    </b-button>&nbsp;
                  </div>
                </b-col>
              </b-row>
            </b-col>

            <b-col lg="8">
              <b-row>
                <b-col>Your attendance draft</b-col>
              </b-row>
              <b-row>
                <b-col>
                  <global-table
                    :table-data="myDraft"
                    :loading="loadingGetList"
                    :per-page="10"
                    :bordered="true"
                    :table-detail="tableDetail"
                    :hover="true"
                    :striped="false"
                    :fields="fieldsDraft"
                    :redirect-detail="false"
                    :show-add-button="false"
                    :edit-button="false"
                    :remove-button="true"
                    @removeForm="removeAttendance"
                  ></global-table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div class="float-right">
            <b-button type="button" size="sm" variant="danger" @click="cancelAddMultiple">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
            <b-button
              type="submit"
              size="sm"
              variant="primary"
              :disabled="myDraft.length === 0"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </div>

        <div v-else>
          <loading></loading>
        </div>
      </b-form>
    </b-modal> -->

    <b-modal
      ref="absensiForm"
      id="addModals"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Absensi Kehadiran Karyawan</h3>
      </div>

      <b-form
        id="attendanceForm"
        validated
        novalidate
        @submit="submitAttendance"
      >
        <div v-if="!loadingSubmit">
          <b-row>
            <b-col sm="3">
              <b-form-group label-for="attendance_status" label="Status">
                <model-select
                  id="attendance_status"
                  :options="listAttendanceStatus"
                  v-model="$v.attendanceForm.attendance_status.$model"
                  :isError="$v.attendanceForm.attendance_status.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="attendanceForm.attendance_status === null"
                  class="invalid-feedback-custom"
                >
                  Status kehadiran harus di isi.
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="flagValue !== '-' && flagValue !== null">
            <b-col sm="6">
              <b-form-group label-for="file" label="Upload Dokumen Adjust File">
                <b-form-file
                  ref="inputDocument"
                  accept="image/*"
                  @change="OnFileSelected($event)"
                  v-model="attendanceForm.file"
                ></b-form-file>
                <div
                  v-if="
                    attendanceForm.file === null ||
                    attendanceForm.file === undefined
                  "
                  class="invalid-feedback-custom"
                >
                  Dokumen harus di isi.
                </div>
              </b-form-group>
            </b-col>

            <b-col sm="6">
                <b-img v-if="attendanceForm.path_file !== null" :src="imgpath+attendanceForm.path_file" fluid></b-img>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6">
              <b-form-group label-for="notes" label="Notes">
                <b-form-textarea
                  id="notes"
                  :rows="3"
                  :max-rows="6"
                  v-model="$v.attendanceForm.notes.$model"
                  :state="!$v.attendanceForm.notes.$invalid"
                ></b-form-textarea>
                <b-form-invalid-feedback
                  >Notes harus di isi.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>

          <div class="float-right">
            <b-button
              type="button"
              size="sm"
              variant="danger"
              @click="cancelAdd"
            >
              <i class="fa fa-undo"></i> Back </b-button
            >&nbsp;
            <b-button
              type="submit"
              size="sm"
              variant="primary"
              :disabled="$v.attendanceForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </div>

        <div v-else>
          <loading></loading>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      ref="listHistory"
      id="listHistory"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">List History</h3>
      </div>

      <div v-if="!loadingGetList">
        <global-table
          :table-data="listHistoryEmployee"
          :loading="loadingGetList"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fieldsHistory"
          :redirect-detail="false"
          :show-add-button="false"
        ></global-table>

        <div class="float-right">
          <b-button
            type="button"
            size="sm"
            variant="danger"
            @click="cancelHistory"
          >
            <i class="fa fa-undo"></i> Back </b-button
          >&nbsp;
        </div>
      </div>

      <div v-else>
        <loading></loading>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import attendanceList from "./EmployeeAttendanceList";
import VueNotifications from "vue-notifications";
import { required, email } from "vuelidate/lib/validators";
import interfaces from "@/templates/_interfaces.js";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import globalTable from "@/templates/Table.vue";
import _accessApi from "@/router/_accessApi.js";

export default {
  name: "employee-attendance",
  components: { attendanceList, ModelSelect, loading, globalTable },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      listAttendance: [],
      listEmployee: [],
      listEmployeeDivision: [],
      listEmployeePosition: [],
      listEmployeeStatus: [],
      tempEmployeePosition: [],
      listAttendanceStatus: [],
      listHistoryEmployee: [],
      listYear: [],
      listMonth: [],
      attendanceForm: interfaces.employee_attendance,
      loadingSubmit: false,
      loadingGetList: false,
      loading: false,
      day_in_month: 0,
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MM"),
      currentDivision: null,
      currentPosition: null,
      currentStatus: null,
      fieldsHistory: [
        {
          key: "attendance_date",
          label: "Tanggal Absen",
          class: "width-150",
          sortable: true,
        },
        {
          key: "distance",
          label: "Jarak Absen",
          class: "width-150",
          sortable: true,
        },
        {
          key: "attendance_status_name",
          label: "Status Absen",
          class: "text-center width-150",
        },
        { key: "notes", label: "Notes" },
      ],

      fieldsDraft: [
        {
          key: "attendance_date",
          label: "Tanggal Absen",
          class: "width-150",
          sortable: true,
        },
        {
          key: "b",
          label: "Karyawan",
          class: "width-150",
          sortable: true,
        },
        {
          key: "c",
          label: "Status Karyawan",
          class: "width-150",
          sortable: true,
        },
        { key: "d", label: "Notes" },
        { key: "action", class: "width-50 text-center" },
      ],
      myDraft: [],
      tempEmployeeMultiple: { value: "", text: "" },
      tempEmployeeStatus: { value: "", text: "" },
      addData: [],
      postStatusId: [],
      flagValue: null,
      imgpath:
        location.host === "localhost:8080"
          ? _accessApi.localhost.upload_path
          : _accessApi.server.upload_path,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations() {
    if (this.flagValue !== "-") {
      return {
        attendanceForm: {
          employee_id: { required },
          attendance_date: { required },
          attendance_status: { required },
          notes: { required },
          file: { required },
        },
      };
    } else {
      return {
        attendanceForm: {
          employee_id: { required },
          attendance_date: { required },
          attendance_status: { required },
          notes: { required },
          file: {  },
        },
      };
    }
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    init: function () {
      this.getDropdownAttendance();
      this.getListingAttendance();
    },
    OnFileSelected: function (event) {
      this.attendanceForm.file = event.target.files[0];
    },
    getListingAttendance: function () {
      let addition = this;
      this.loading = true;
      let data = {
        month: this.currentMonth,
        year: this.currentYear,
        division: this.currentDivision,
        position: this.currentPosition,
        status: this.currentStatus,
      };

      //+'/'+this.currentYearthis.currentMonth+'/'+this.currentYear
      this.axios
        .post("web/employee/list-attendance/today/", data)
        .then((response) => {
          this.listAttendance = response.data.data;
          this.day_in_month = response.data.day_in_month;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdownAttendance: function () {
      this.axios
        .get("web/dropdown/dropdown-employee-attendance/")
        .then((response) => {
          this.listEmployee = response.data.employee;
          this.listAttendanceStatus = response.data.attendance_status;
          this.listYear = response.data.year;
          this.listMonth = response.data.month;
          this.listEmployeeDivision = response.data.employee_division;
          this.listEmployeeStatus = response.data.employee_status;
          this.tempEmployeePosition = response.data.employee_position;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {});
    },
    openAttendanceForm: function (data) {
      this.resetForm();
      let date = this.currentYear + "-" + this.currentMonth + "-" + data.day;
      this.attendanceForm.attendance_date = new Date(date);
      this.attendanceForm.attendance_status = data.value !== "-" ? data.value : null;
      this.attendanceForm.employee_id = data.employee_id;
      this.attendanceForm.notes = data.notes;
      this.attendanceForm.path_file = data.path_file;

      this.flagValue = data.value;
      this.$refs.absensiForm.show();
    },
    openMultipleAttendanceForm: function () {
      this.resetForm();
      this.myDraft = [];
      this.attendanceForm.attendance_date = new Date();
      this.$refs.multipleAbsensiForm.show();
    },
    submitAttendance: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda yakin ?")) {
        this.loadingSubmit = true;
        let formData = new FormData();
        formData.append("employee_id", this.attendanceForm.employee_id);
        formData.append(
          "attendance_status",
          this.attendanceForm.attendance_status
        );
        formData.append(
          "attendance_date",
          moment(this.attendanceForm.attendance_date).format("YYYY-MM-DD")
        );
        formData.append("inserted_time", this.attendanceForm.inserted_time);
        formData.append("updated_by", this.attendanceForm.updated_by);
        formData.append("notes", this.attendanceForm.notes);
        formData.append("file", this.attendanceForm.file);
        formData.append("inserted_by", localStorage.getItem("employee_id"));

        // formData.append("asset_owner_id", this.assetForm.asset_owner_id);
        // formData.append("serial_number", this.assetForm.serial_number);
        // formData.append("file", this.assetForm.file);
        // formData.append("description", this.assetForm.description);
        // formData.append("status", this.assetForm.status);
        // formData.append("image_information", this.assetForm.image_information);
        // formData.append("inserted_by", localStorage.getItem("employee_id"));

        // let attendance = this.attendanceForm;
        // attendance.inserted_by = localStorage.getItem("employee_id");
        this.axios
          .post("web/employee/add-attendance/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Absensi Karyawan",
                message: response.data.message,
              });
              this.init();
              this.cancelAdd();
            }
          })
          .catch((error) => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmit = false;
          });
      }
      //console.log(this.attendanceForm);
    },
    addMultipleAttendance: function () {
      let data = {};
      data.attendance_date = moment(this.attendanceForm.attendance_date).format(
        "YYYY-MM-DD"
      );
      data.b = this.tempEmployeeMultiple.text;
      data.c = this.tempEmployeeStatus.text;
      data.d = this.attendanceForm.notes;
      data.employee_id = this.tempEmployeeMultiple.value;
      data.attendance_status = this.tempEmployeeStatus.value;
      data.notes = this.attendanceForm.notes;
      let check = this.myDraft.filter(
        (x) =>
          x.employee_id === data.employee_id &&
          x.attendance_date === data.attendance_date
      );
      if (check.length === 0) {
        if (data.employee_id !== "" && data.attendance_status !== "") {
          this.myDraft.push(data);
        }
      } else {
        alert("Data sudah di masukkan");
      }
      this.resetForm();
      this.attendanceForm.attendance_date = new Date();
    },
    multipleSubmitAttendance: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda yakin ?")) {
        this.loadingSubmit = true;
        let attendance = {};
        attendance.inserted_by = localStorage.getItem("employee_id");
        attendance.data = this.myDraft;
        this.axios
          .post("web/employee/multiple-post-attendance/", attendance)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Absensi Karyawan",
                message: response.data.message,
              });
              this.init();
              this.cancelAddMultiple();
            }
          })
          .catch((error) => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmit = false;
          });
      }
    },
    cancelAdd: function () {
      this.resetForm();
      this.$refs.absensiForm.hide();
    },
    cancelAddMultiple: function () {
      this.resetForm();
      this.$refs.multipleAbsensiForm.hide();
    },
    resetForm: function () {
      for (var a in interfaces.employee_attendance) {
        interfaces.employee_attendance[a] = null;
      }
      this.attendanceForm = interfaces.employee_attendance;
      this.tempEmployeeMultiple = { value: "", text: "" };
      this.tempEmployeeStatus = { value: "", text: "" };
    },
    setSelected: function (event) {
      this.currentPosition = null;
      this.listEmployeePosition = this.tempEmployeePosition.filter(
        (x) => x.division_id === event
      );
    },
    getListHistory: function (month, year, employee_id) {
      this.$refs.listHistory.show();
      let data = {
        month: month,
        year: year,
        employee_id: employee_id,
      };
      this.axios
        .post("web/employee/list-history-attendance/", data)
        .then((response) => {
          this.listHistoryEmployee = response.data.data;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {});
    },
    cancelHistory: function () {
      this.$refs.listHistory.hide();
    },
    removeAttendance: function (data) {
      this.myDraft = this.myDraft.filter((x) => x.b !== data.b);
    },
    changeEmployeeMultiple: function () {
      this.attendanceForm.employee_id = this.tempEmployeeMultiple.value;
    },
    changeEmployeeStatus: function () {
      this.attendanceForm.attendance_status = this.tempEmployeeStatus.value;
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>
